import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import styles from './Login.module.css';

const Login = ({ setAuthenticated }) => {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const navigate = useNavigate();

  const handleLogin = (e) => {
    e.preventDefault();
    // Fixed credentials check
    if (username === 'admin' && password === 'apnec1978') {
      setAuthenticated(true);
      localStorage.setItem('auth', 'true');
      navigate('/dashboard');
    } else {
      alert('Galat username ya password!');
    }
  };

  return (
    <div className={styles.loginContainer}>
      <div className={styles.loginBox}>
        <h2>Admin Access</h2>
        <form onSubmit={handleLogin}>
          <input 
            className={styles.inputField} 
            type="text" 
            placeholder="Username" 
            onChange={(e) => setUsername(e.target.value)} 
            required 
          />
          <input 
            className={styles.inputField} 
            type="password" 
            placeholder="Password" 
            onChange={(e) => setPassword(e.target.value)} 
            required 
          />
          <button className={styles.loginBtn} type="submit">LOGIN</button>
        </form>
      </div>
    </div>
  );
};

export default Login;